<!-- =========================================================================================
  File Name: StealsVehicleType.vue
  Description: Steals by vehicle type
  ----------------------------------------------------------------------------------------
  Item Name: C4 - User list for management
  Author: Oscar Ramírez O.
  Author URL: https://acentoNET.com
========================================================================================== -->

<template>
  <div>
    <div class="vx-col w-full mb-base">
      <vx-card class="mb-2">
        <div class="flex flex-row">
          <vx-card class="w-8/12 mb-2 mr-4" title="Robos - Últimos 180 días">
            <div class="flex flex-row w-full">
              <apexcharts class="flex w-full" type="bar" height="500" :options="chart1.chartOptions" :series="chart1.series"></apexcharts>
            </div>
          </vx-card>
          <vx-card class="w-4/12 mb-2" :title="heatMapTitle" v-if="loaded">
            <div class="flex flex-row w-full">
              <apexcharts class="flex w-full" type="heatmap" height="500" :options="chart2.chartOptions" :series="chart2.series"></apexcharts>
            </div>
          </vx-card>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
  import VueApexCharts from 'vue-apexcharts';

  export default {
    data() {
      return {
        loaded: false,
        heatMapTitle: 'Mapa de calor',
        data: [],
        chart1: {
          series: [],
          chartOptions: {
            chart: {
              id: 'chart1',
              instance: this,
              events: {
                dataPointSelection: function (e, chart, opts) {
                  chart.opts.chart.instance.getHeatMap(chart.opts.series[0].data[opts.dataPointIndex].t, chart.opts.series[0].data[opts.dataPointIndex].n);
                }
              }
            },
            legend: {
              show: false
            },
            plotOptions: {
              bar: {
                barHeight: '100%',
                distributed: true,
                horizontal: false,
                dataLabels: {
                  position: 'bottom'
                }
              }
            }
          }
        },
        chart2: {
          series: [],
          chartOptions: {
            chart: {id: 'chart2'},
            legend: {
              show: false
            },
            colors: ["#FF0000"]
          }
        }
      }
    },
    components: {
      apexcharts: VueApexCharts
    },
    computed: {
      api() {
        return this.$store.getters.getParameter('connection').apiURL;
      }
    },
    methods: {
      getTop10Auto() {
        const self = this;
        this.$http.post(`${this.api}/statistics/top10steals`).then(response => {
          if (response.data.success) {
            if (response.data.data) {
              let data = [];
              for (let i = 0; i < response.data.data.length; i++) {
                data.push({x: response.data.data[i].name, y: response.data.data[i].quantity, t: response.data.data[i].vehicleType, n: response.data.data[i].name});
              }
              self.chart1.series.push({name: 'Siniestros', data: data});
            } else {
              self.data = [];
            }
            self.gridReady = true;
          } else {
            self.$vs.notify({
              title: 'Error al cargar Top 10 por tipo de vehículo',
              text: response.data.message,
              color: 'danger'
            });
          }
          self.$vs.loading.close();
        }).catch(error => {
          self.$vs.loading.close();
          let errorMessage = '';
          if (error.message) {
            errorMessage = error.message;
          } else if (error.response) {
            errorMessage = error.response.data.ErrorMessage;
          } else {
            errorMessage = 'Error de conectividad'
          }
          self.$vs.notify({
            title: 'Error al cargar Top 10 por tipo de vehículo',
            text: errorMessage,
            color: 'danger'
          });
        });
      },
      getHeatMap(vehicleType, name) {
        this.$vs.loading({
          text: 'Cargando mapa de calor',
          type: 'point'
        });
        const self = this;
        this.$http.post(`${this.api}/statistics/heatMapVehicleType`, {vehicleType: vehicleType}).then(response => {
          if (response.data.success) {
            if (response.data.data) {
              let data = [];
              for (let i = 0; i < response.data.data.length; i++) {
                data.push({name: response.data.data[i].code, data: [
                    {x: 'DO', y: response.data.data[i].sunday},
                    {x: 'LU', y: response.data.data[i].monday},
                    {x: 'MA', y: response.data.data[i].tuesday},
                    {x: 'MI', y: response.data.data[i].wednesday},
                    {x: 'JU', y: response.data.data[i].thursday},
                    {x: 'VI', y: response.data.data[i].friday},
                    {x: 'SA', y: response.data.data[i].saturday}
                ]});
              }
              self.chart2.series = data;
            }
            self.heatMapTitle = name;
            self.gridReady = true;
          } else {
            self.$vs.notify({
              title: 'Error al cargar Top 10 por zona',
              text: response.data.message,
              color: 'danger'
            });
          }
          this.$vs.loading.close();
          self.loaded = true;
        }).catch(error => {
          this.$vs.loading.close();
          var errorMessage = '';
          if (error.message) {
            errorMessage = error.message;
          } else if (error.response) {
            errorMessage = error.response.data.ErrorMessage;
          } else {
            errorMessage = 'Error de conectividad'
          }
          self.$vs.notify({
            title: 'Error al cargar Top 10 por zona',
            text: errorMessage,
            color: 'danger'
          });
        });
      }
    },
    mounted() {
      this.$vs.loading({
        text: 'Cargando estadísticas',
        type: 'point'
      });
      this.getTop10Auto();
    }
  }

</script>
